import { module } from 'modujs';
import VueProductRecommendations from '../vue/components/VueProductRecommendations';
import VueProductRecommendationsItem from '../vue/components/VueProductRecommendationsItem';


export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$el = this.el
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        // Init vue
        this.initVue();
    }

    destroy() {
        super.destroy();
        this.app?.$destroy?.()
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Vue Components
        VueProductRecommendations(moduleInstance)
        VueProductRecommendationsItem(moduleInstance)

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el
        });
    }

    /////////////////////////
    // Data
    getProductRecommandations(productId) {
        return fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=3`)
        .then(response => response.json())
        .then(({ products }) => {
            return products;
        })
    }
}
